<template>
  <div class="home">
    <tickets :ticket="ticket"></tickets>
    <pay class="mt" @getPayStatus="getPayStatus" v-if="ticket.amount"></pay>
    <Footer @pay="pay"></Footer>
    <payModel v-if="isok" @closeMolel="closeMolel" :orderNo="this.ticket.orderNo" isfrom="ticket"></payModel>
  </div>
</template>
<script>
import Pay from '../../components/pay/index.vue'
import Tickets from '../../components/ticketsInfo/index.vue'
import Footer from '../../components/footer/index.vue'
import payModel from '../../components/payModel/index.vue'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  data() {
    return {
      ticket: {},
      payType: 0,
      isok: false
    }
  },
  components: {
    Pay,
    Tickets,
    Footer,
    payModel
  },
  methods: {

    getPayStatus(type) {
      this.payType = type
    },
    async saveuser() {
      const data = JSON.parse(localStorage.getItem('userInfo'))
      const url = apis.saveUser
      const res = await http.post(url, data)
      if (res.code === 0) {
        this.$alert('报名成功', '',{
          showClose: false
        })
      } else {
        this.$alert(res.msg, '',{
          showClose: false
        })
      }
    },
    async pay() {
      if(!this.ticket.amount){
          const data = {
              orderNo: this.ticket.orderNo,
              payType: 5
          }
          const res = await http.post('/renren-fast/app/audience/createAudience', data)
          if(res.code === 0){
              const audienceIdAndMeetingId = {meetingId: this.meetingId,audienceId: res.id}
              localStorage.setItem('audienceId', res.id)
              localStorage.setItem('audienceIdAndMeetingId',JSON.stringify(audienceIdAndMeetingId))
              this.$router.push('/pay_success?from=ticket')
          }
          console.log(res)
          return
      }
      const data = {
        orderNo: this.ticket.orderNo,
        payType: this.payType
      }
      console.log(this.payType)
      if(!this.payType){
            this.$alert('请先选择支付方式', '',{
                showClose: false
            })
            return
        }
      // pc端
      if (this.payType == 2 && this.isPc) {
        console.log('pc端支付')
        const params = {
          orderNo: this.ticket.orderNo
        }
        const res =await http.get(apis.pcwxPay, {params})
        console.log('pc支付',res)
        localStorage.setItem('payurl',res.payResult.codeUrl)
        // 生成二维码-
        this.$router.push("/pc_pay")
        return
        // 移动端  使用公众号支付 获取后台返回的参数 调用微信支付
      } 
      if (this.payType == 2 && !this.isPc) {
        const vm = this
        var is_weixin = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })();
        if (is_weixin) {
          console.log('微信支付  移动端微信内部')
          var prepay_id;
          var sign;
          var appId;
          var timeStamp;
          var nonceStr;
          var packageStr;
          var signType;
          var url = apis.h5webpay;//后台路径
          console.log('localStorage.getItem(openId)', localStorage.getItem('openId'))

          let params={ openId: localStorage.getItem('openId'),orderNo: this.ticket.orderNo }
          const res = await http.get('http://web.nmep.com.cn:8080' + url, {params})
          console.log('支付参数res',res)
          if (res.code == 0) {
            appId = res.payResult.appId;
            sign = res.payResult.paySign;
            timeStamp = res.payResult.timeStamp;
            nonceStr = res.payResult.nonceStr;
            packageStr = res.payResult.packageValue; //没有
            signType = res.payResult.signType;
            //调起微信支付控件
            callpay();
          } else {
            alert("统一下单失败");
          }
          function onBridgeReady() {
            WeixinJSBridge.invoke(
              'getBrandWCPayRequest', {
              "appId": appId,     //公众号名称，由商户传入
              "paySign": sign,         //微信签名
              "timeStamp": timeStamp, //时间戳，自1970年以来的秒数
              "nonceStr": nonceStr, //随机串
              "package": packageStr,  //预支付交易会话标识
              "signType": signType     //微信签名方式
            },
               (res) => {
                //alert(JSON.stringify(res));
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  // window.location.replace("https://www.baidu.com");
                  vm.$router.push('/pay_success?from=ticket')
                } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  alert('支付取消');
                } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                  alert('支付失败');
                }
                //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
              }
            );
          }

          function callpay() {
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            } else {
              onBridgeReady();
            }
          }
          return
        }
      }
      const res = await http.post('/renren-fast/app/h5pay/wxPay', data)
      if (res.code === 0) {
        const audienceIdAndMeetingId = {meetingId: this.meetingId,audienceId: res.returnMap.id}
        localStorage.setItem('audienceId', res.returnMap.id)
        localStorage.setItem('audienceIdAndMeetingId',JSON.stringify(audienceIdAndMeetingId))
        if (this.payType == 2 || this.payType == 1) {
          window.location.href = res.returnMap.url
        } else {
          this.$router.push('/pay_success?from=ticket')
        }

      }
    },
    closeMolel() {
         this.isok=false
   
    }
  },
  computed: {
    isPc() {
      return this.$store.state.isPc
    },
    meetingId() {
        return this.$store.state.meetingId || localStorage.getItem('meetingId')
    }
  },
  created(){
    console.log(this.$route.query.isback)
    this.isok = this.$route.query.isback==1
    console.log(this.isback)
   
  },
  mounted() {
    this.ticket = JSON.parse(localStorage.getItem('chooseTicket'))
    // console.log(this.$route.query.isback)
    // this.isback = this.$route.query.isback==1
    // console.log(this.isback)
    // if(this.$route.query.isback){
    //   this.$confirm('请确认微信支付是否已完成', '', {
    //       confirmButtonText: '支付完成',
    //       cancelButtonText: '支付遇到了问题，重新支付',
    //       center: true
    //   }).then(() => {
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });          
    //   });
    // }
  }
}
</script>
<style lang="stylus" scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background: #f1f1f1;
  box-sizing: border-box;
  padding-bottom: 100px;
}

.mt {
  margin-top: 22px;
}

@media screen and (min-width: 800px) {
  .home {
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #f1f1f1;
    box-sizing: border-box;
    padding-bottom: 100px;
  }

  .mt {
    margin-top: 22px;
  }
}
</style>
